import { Grid } from "@mui/material";
import { ModuleUIModel } from "components/Evaluation/Models/ModuleUIModel";
import { EvalStore } from "components/Evaluation/Stores/EvalStore";
import { AcxGradientTypography } from "components/UI/AcxGradientTypography";
import { AcxViewLLMReasoningButton } from "components/UI/AcxLLMReasoning";
import AcxStatusSticker from "components/UI/AcxStatusSticker";
import { observer } from "mobx-react";
import Question from "models/Question";
import React from "react";
import { AcxLLMSmartPredictIcon } from "SvgIcons/AcxLLMSmartPredictIcon";
import HelpSvg from "SvgIcons/HelpSvg";
import { useStore } from "utils/useStore";

interface OwnProps {
    question: Question;
    moduleUIModel?: ModuleUIModel;
}

type Props = OwnProps;

const SmartPredictToggle = observer((props: Props) => {
    const store = useStore(EvalStore);

    function showExplanation() {
        store.setShowAIExplanation(
            props.question.id,
            !store.showAIExplanation[props.question.id],
        );
    }

    const answer = store.currentEval?.getAnswerForQuestion(
        props.question,
        props.moduleUIModel?.licensedModule.evaluationModuleId,
    );

    const isSmartPredicted = answer?.hasAccuratePredictions;
    if (!isSmartPredicted) return null;

    const isLLMPredicted = answer?.hasLLMPrediction;

    const hasMlModel: boolean = !!answer?.predictedTags.find((item) => {
        // There's some risk to showing the other models and getting it wrong.
        // We should restrict all the other ML models but leave Eddy.
        return (
            item.predictedBy.startsWith("ML") &&
            !["ML-EddyEffect", "ML-EddyEffectP2"].includes(item.predictedBy)
        );
    });

    return (
        <Grid
            container
            item
            flexWrap="nowrap"
            alignItems="center"
            width="max-content"
            flex={1}
        >
            {!isLLMPredicted && (
                <AcxStatusSticker
                    title={"Smart Predict"}
                    customRootStyles={{
                        width: "max-content",
                    }}
                />
            )}
            {isLLMPredicted && (
                <Grid container item alignItems="center" columnGap={1}>
                    <AcxLLMSmartPredictIcon />
                    <AcxGradientTypography>Smart Predict</AcxGradientTypography>
                </Grid>
            )}
            {store.authStore.canUserView("AI Scoring Explanations") &&
                !hasMlModel && (
                    <React.Fragment>
                        {!isLLMPredicted && (
                            <Grid
                                item
                                id="ai-explanation-icon"
                                alignItems="center"
                                component="span"
                                role="button"
                                width="20px"
                                height="20px"
                                sx={{ cursor: "pointer" }}
                                onClick={showExplanation}
                            >
                                <HelpSvg />
                            </Grid>
                        )}
                        {isLLMPredicted && (
                            <AcxViewLLMReasoningButton
                                alignSelf="flex-end"
                                whiteSpace="nowrap"
                                onClick={showExplanation}
                            />
                        )}
                    </React.Fragment>
                )}
        </Grid>
    );
});

export default SmartPredictToggle;
